import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';
import type {
  SmtAvailabilityDispatchResult,
  SmtAvailabilityIntent,
  SmtAvailabilityViewModel,
} from '../../../packages/runtime/smt-availability-contract.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;
type AvailabilityRuntime = Pick<BusinessRuntime, 'smtAvailability'>;

export interface SmtAvailabilityPortConfig {
  readonly operatorId: string;
  readonly now: () => string;
  readonly nextIdempotencyKey: () => string;
}

export interface SmtAvailabilityPort {
  readAvailability(): Promise<SmtAvailabilityViewModel>;
  dispatchAvailability(intent:SmtAvailabilityIntent, expectedRevision:number):Promise<SmtAvailabilityDispatchResult>;
}

export function createSmtAvailabilityPort(
  runtime:AvailabilityRuntime,
  config:SmtAvailabilityPortConfig,
):SmtAvailabilityPort {
  const request=()=>({actorId:config.operatorId,at:config.now()});

  return {
    async readAvailability(){
      return runtime.smtAvailability.snapshot(request());
    },
    async dispatchAvailability(intent,expectedRevision){
      return runtime.smtAvailability.dispatch(intent,{
        ...request(),
        expectedRevision,
        idempotencyKey:config.nextIdempotencyKey(),
      });
    },
  };
}
